// FilterDropdown.jsx
import React from "react";

class FilterDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
        this.containerRef = null;
    }

    componentDidMount() {
        if (typeof document !== "undefined") {
            document.addEventListener("click", this.handleDocumentClick, true);
        }
    }

    componentWillUnmount() {
        if (typeof document !== "undefined") {
            document.removeEventListener("click", this.handleDocumentClick, true);
        }
    }

    setContainerRef = (node) => {
        this.containerRef = node;
    };

    handleDocumentClick = (e) => {
        if (!this.containerRef) return;
        if (this.containerRef.contains(e.target)) return;
        if (this.state.open) {
            this.setState({ open: false });
        }
    };

    toggleOpen = () => {
        this.setState((prev) => ({ open: !prev.open }));
    };

    close = () => {
        this.setState({ open: false });
    };

    render() {
        const { open } = this.state;
        const { label, children } = this.props;
        let cls="ff-filter__menu";
        if(label==="Sort By"){
            cls+=" sort-menu";
        }
        let mainCls='ff-filter';
        if(this.props.cls) mainCls+=' '+this.props.cls;
        return (
            <div className={mainCls} ref={this.setContainerRef}>
                <button
                    type="button"
                    className="ff-filter__trigger"
                    onClick={this.toggleOpen}
                >
                    <span className="ff-filter__label">{label}</span>
                    <img
                        src="/images/icons/dropdown-arrow.png"
                        alt=""
                        className={
                            "ff-filter__icon" + (open ? " ff-filter__icon--open" : "")
                        }
                    />
                </button>

                {open && (
                    <div className={cls}>
                        {typeof children === "function"
                            ? children({ close: this.close })
                            : children}
                    </div>
                )}
            </div>
        );
    }
}

export default FilterDropdown;
